import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 100%;
  margin-top: 3rem;
`;

export const Label = styled.div`
  height: 6rem;
  width: 6rem;
  background: #fafbfb;
  border-radius: 1rem;
  background: #539ada;
  ${({ theme }) => theme.clickable};
  display: flex;
  justify-content: center;
  align-items: center;
  color: #0e067d;
  font-size: 1.6rem;
  font-weight: 400;
`;
